import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import { IQueueExecutionCustomPlotsProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import SchemaGenerator from "./SchemaGenerator";
import { PlotFieldType } from "@/components/Plotting/models/PlotFieldType";


export class CustomPlotsSchemaGenerator extends SchemaGenerator<IQueueExecutionCustomPlotsProp> {

    public createRootSchema(): JsonEditorSchema<IQueueExecutionCustomPlotsProp> {

        const rootSchema: JsonEditorSchema<IQueueExecutionCustomPlotsProp> = {
            type: 'object',
            additionalProperties: false,
            properties: {
                plots: {
                    type: 'array',
                    items: {
                        type: 'object',
                        additionalProperties: true,
                        properties: {
                            type: { type: 'string' }
                        },
                        required: ["type"]
                    }
                }
            },
            required: ['plots'],
        };

        return rootSchema;
    }

    public mapType(fieldType: any): JsonEditorType | null {
        switch (fieldType) {
            case PlotFieldType.Text:
            case PlotFieldType.Select:
            case PlotFieldType.SelectOrCreate:
            case PlotFieldType.ColumnSelectOrCreate:
            case PlotFieldType.ColumnSelect:
            case PlotFieldType.SelectJson:
            case PlotFieldType.ColorPicker:
            case PlotFieldType.StringTemplate:
            case PlotFieldType.RegularExpression:
            case PlotFieldType.ParamSelect:
            case PlotFieldType.ParamSelectOrCreate:
            case PlotFieldType.ParamOrColumnSelect:
            case PlotFieldType.ParamOrColumnSelectOrCreate:
            case PlotFieldType.SelectDataSource:
                return 'string';
            case PlotFieldType.Number:
                return 'number';
            case PlotFieldType.Boolean:
                return 'boolean';
            case PlotFieldType.Array:
            case PlotFieldType.ArrayValues:
            case PlotFieldType.MultiSelect:
            case PlotFieldType.ColumnMultiSelect:
            case PlotFieldType.ColumnMultiSelectOrCreate:
            case PlotFieldType.ParamMultiSelect:
            case PlotFieldType.ParamMultiSelectOrCreate:
            case PlotFieldType.ParamOrColumnMultiSelect:
            case PlotFieldType.ParamOrColumnMultiSelectOrCreate:
                return 'array';
            case PlotFieldType.Object:
            case PlotFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public populateVariants(schema: JsonEditorSchema<IQueueExecutionCustomPlotsProp>, variants: Array<any>, options: any): void {

        schema.properties.plots!.items = {
            type: 'object',
            additionalProperties: options.additionalProperties,
            required: ['type'],
            allOf: variants.map((variant: any) => {
                const { type: _t, ...otherProps } = variant.properties;
                const typeValue = variant.properties.type?.enum?.[0];
                return {
                    if: {
                        properties: { type: { const: typeValue } },
                        required: ['type']
                    },
                    then: {
                        properties: otherProps,
                        ...(variant.required?.length > 1
                            ? { required: variant.required }
                            : {})
                    }
                };
            })
        };

    }
}

export default CustomPlotsSchemaGenerator;
